import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { func, string, bool } from 'prop-types';
import Modal from 'react-modal';

import ModalActions from '~redux/Modal/actions';

import styles from './styles.module.scss';

function CustomModal({
  children,
  hideCloseButton,
  className,
  overlayClassName,
  shouldReturnFocusAfterClose,
  shouldCloseOnOverlayClick,
  disableCloseButton,
  onClose,
  modal,
  isOpen,
  ...props
}) {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(ModalActions.closeModal(modal));
  const clearAllModals = () => dispatch(ModalActions.clearModals());

  const clearModals = () => {
    if (onClose) {
      onClose();
    }
    clearAllModals();
  };

  useEffect(() => {
    window.addEventListener('popstate', clearModals, false);
    return () => {
      window.removeEventListener('popstate', clearModals);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
    closeModal(modal);
  };

  return (
    <Modal
      {...props}
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      className={`${styles.modalContainer} ${className}`}
      overlayClassName={`${styles.modalOverlay} ${overlayClassName}`}
      shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
      bodyOpenClassName={styles.body}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}>
      <>
        {!hideCloseButton && (
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleCloseModal}
            disabled={disableCloseButton}>
            <i className={`icon-close ${styles.iconClose}`} />
          </button>
        )}
        {children}
      </>
    </Modal>
  );
}

CustomModal.propTypes = {
  modal: string.isRequired,
  className: string,
  disableCloseButton: bool,
  hideCloseButton: bool,
  isOpen: bool,
  overlayClassName: string,
  shouldCloseOnOverlayClick: bool,
  shouldReturnFocusAfterClose: bool,
  onClose: func
};

CustomModal.defaultProps = {
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: false
};

export default CustomModal;
